import * as fs from "fs/promises";
import type { StorageImageTransformMetric, StorageMeteringOptions } from "./storage-types.js";

export async function recordStorageImageTransform(
  options: StorageMeteringOptions | undefined,
  cachePath: string,
  metric: Omit<StorageImageTransformMetric, "transformCount" | "outputBytes">,
): Promise<{ size: number }> {
  const stats = await fs.stat(cachePath);
  if (!options?.onImageTransform) return stats;

  try {
    await options.onImageTransform({
      ...metric,
      transformCount: 1,
      outputBytes: stats.size,
    });
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    console.warn(`[storage] image transform metering failed: ${msg.slice(0, 120)}`);
  }

  return stats;
}
